import type { RouteRecordRaw } from 'vue-router'

const controlRoutes: RouteRecordRaw[] = [
  {
    path: 'control',
    name: 'control',
    meta: {
      titleKey: 'routes.control.title',
      icon: 'Operation',
      helpKey: 'control'
    },
    redirect: { name: 'device-status' },
    children: [
      {
        path: 'device-status',
        name: 'device-status',
        component: () => import('@/views/control/DeviceStatus.vue'),
        meta: { titleKey: 'routes.control.device-status.title', helpKey: 'device_status' }
      },
      {
        path: 'message-flow',
        name: 'message-flow',
        component: () => import('@/views/control/MessageFlow.vue'),
        meta: { titleKey: 'routes.control.message-flow.title', helpKey: 'message_flow' }
      },
      {
        path: 'announcements',
        name: 'control-announcements',
        component: () => import('@/views/control/Announcements.vue'),
        meta: { titleKey: 'routes.control.announcements.title', helpKey: 'control_announcements' }
      }
    ]
  }
]

export default controlRoutes

